import React from 'react';
import { MapPin, Phone, Mail, Instagram } from 'lucide-react';
import { clinicInfo } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-slate-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* About */}
          <div>
            <h3 className="text-2xl font-bold mb-4 bg-gradient-to-r from-cyan-400 to-teal-400 bg-clip-text text-transparent">
              Shubh Wellness Clinic
            </h3>
            <p className="text-gray-300 mb-4">
              Your trusted partner in health and wellness. Certified professionals dedicated to helping you achieve optimal well-being.
            </p>
            <div className="inline-flex items-center bg-green-900/30 border border-green-500/50 rounded-lg px-4 py-2">
              <svg className="w-5 h-5 text-green-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="text-green-300 font-medium text-sm">Direct Insurance Billing Available</span>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xl font-semibold mb-4 text-cyan-400">Contact Us</h4>
            <div className="space-y-3">
              <div className="flex items-start">
                <MapPin className="h-5 w-5 text-cyan-400 mr-3 mt-1 flex-shrink-0" />
                <p className="text-gray-300">{clinicInfo.address.full}</p>
              </div>
              <div className="flex items-center">
                <Phone className="h-5 w-5 text-cyan-400 mr-3 flex-shrink-0" />
                <a href={`tel:${clinicInfo.phone.replace(/-/g, '')}`} className="text-gray-300 hover:text-cyan-400 transition-colors">
                  {clinicInfo.phone}
                </a>
              </div>
              <div className="flex items-center">
                <Mail className="h-5 w-5 text-cyan-400 mr-3 flex-shrink-0" />
                <a href={`mailto:${clinicInfo.email}`} className="text-gray-300 hover:text-cyan-400 transition-colors break-all">
                  {clinicInfo.email}
                </a>
              </div>
            </div>
          </div>

          {/* Social Media */}
          <div>
            <h4 className="text-xl font-semibold mb-4 text-cyan-400">Follow Us</h4>
            <p className="text-gray-300 mb-4">Connect with us on social media</p>
            <div className="space-y-3">
              {clinicInfo.socialMedia.instagram.map((link, index) => {
                const username = link.split('/').filter(Boolean).pop().split('?')[0];
                return (
                  <a
                    key={index}
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center text-gray-300 hover:text-cyan-400 transition-colors group"
                  >
                    <Instagram className="h-5 w-5 mr-3 group-hover:scale-110 transition-transform" />
                    <span>@{username}</span>
                  </a>
                );
              })}
              <a
                href={clinicInfo.socialMedia.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center text-gray-300 hover:text-cyan-400 transition-colors group"
              >
                <svg className="h-5 w-5 mr-3 group-hover:scale-110 transition-transform" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
                <span>@shubhwellnessclin</span>
              </a>
            </div>
          </div>
        </div>

        {/* Hours */}
        <div className="border-t border-gray-700 pt-8 mb-8">
          <h4 className="text-xl font-semibold mb-4 text-cyan-400 text-center">Hours of Operation</h4>
          <div className="flex justify-center">
            <div className="text-center">
              <p className="font-semibold text-white text-lg">Monday - Sunday</p>
              <p className="text-gray-300 text-lg">10:00 AM - 7:00 PM</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 text-center">
          <p className="text-gray-400">
            © {new Date().getFullYear()} Shubh Wellness Clinic. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
